var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 60,
    height: 60,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#004899"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(8 8)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 31.25V26.75H24V31.25H48Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40.25V35.75H24V40.25H48Z",
    fill: "#E53323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22.25V17.75H24V22.25H48Z",
    fill: "#E53323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.724 49.244H33.24V50.6H26.724V49.244ZM26.724 52.028H33.24V53.384H26.724V52.028ZM26.724 54.8H33.24V56.204H26.724V54.8ZM25.68 46.46H34.236V56.948H32.712V47.876H27.132V56.948H25.68V46.46ZM37.224 48.836H40.128V50.036H37.224V48.836ZM36.528 50.924H40.68V52.136H36.528V50.924ZM36.504 52.7L37.44 52.46C37.632 53.108 37.812 53.96 37.884 54.512L36.9 54.788C36.852 54.224 36.672 53.36 36.504 52.7ZM36.324 55.46C37.404 55.328 39.06 55.076 40.668 54.824L40.74 55.952C39.3 56.252 37.776 56.54 36.612 56.756L36.324 55.46ZM39.96 52.388L40.872 52.616C40.68 53.312 40.476 54.116 40.308 54.632L39.564 54.416C39.708 53.864 39.888 52.988 39.96 52.388ZM38.124 49.328H39.288V55.76L38.124 55.988V49.328ZM38.472 45.764L39.552 46.16C38.892 47.588 37.776 49.088 36.648 50.024C36.612 49.724 36.36 48.944 36.204 48.608C37.068 47.912 37.956 46.856 38.472 45.764ZM38.304 47.012L39.06 46.208C39.78 46.88 40.836 47.852 41.34 48.416L40.524 49.364C40.044 48.74 39.036 47.732 38.304 47.012ZM46.512 51.572L47.472 52.376C46.968 52.904 46.38 53.48 45.936 53.852L45.156 53.132C45.576 52.748 46.176 52.076 46.512 51.572ZM40.944 52.268L41.892 51.584C42.312 52.028 42.864 52.64 43.128 53.048L42.12 53.804C41.892 53.396 41.352 52.736 40.944 52.268ZM42.552 46.808H45.684V47.9H42.552V46.808ZM42.24 48.584H45.42V49.664H42.24V48.584ZM40.86 50.192H47.58V51.452H40.86V50.192ZM43.452 50.984H44.772V55.724C44.772 56.336 44.688 56.672 44.292 56.876C43.92 57.056 43.404 57.092 42.72 57.092C42.672 56.732 42.504 56.204 42.336 55.856C42.72 55.88 43.152 55.868 43.272 55.868C43.416 55.868 43.452 55.832 43.452 55.712V50.984ZM40.548 55.172C41.124 54.848 41.976 54.308 42.816 53.756L43.224 54.8C42.6 55.292 41.88 55.82 41.268 56.252L40.548 55.172ZM42.324 45.8L43.656 45.944C43.38 47.192 42.996 48.728 42.708 49.664H41.328C41.664 48.668 42.072 47.048 42.324 45.8ZM45.288 46.808H45.444L45.66 46.76L46.644 46.892C46.464 48.08 46.164 49.508 45.9 50.648L44.592 50.48C44.868 49.316 45.168 47.78 45.288 46.964V46.808ZM44.88 54.62L45.636 53.768C46.296 54.212 47.244 54.884 47.712 55.292L46.92 56.264C46.488 55.832 45.552 55.112 44.88 54.62Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatBtn);
export default __webpack_public_path__ + "static/media/float-btn.174907fb213ac8e75142efd96226cbd7.svg";
export { ForwardRef as ReactComponent };